import { useEffect } from 'react'

declare global {
  interface Window {
    fbq: (...args: any[]) => void
    _fbq: any
  }
}

const PIXEL_ID = '794340817049706'

export function useMetaPixel() {
  useEffect(() => {
    // Initialize Meta Pixel
    if (window.fbq) return

    const n: any = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    })

    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'
    document.head.appendChild(t)

    // Fire PageView
    window.fbq('init', PIXEL_ID)
    window.fbq('track', 'PageView')
  }, [])
}

export function trackAddToCart() {
  if (typeof window !== 'undefined' && window.fbq) {
    window.fbq('track', 'AddToCart', {
      content_name: 'Tu Primer Sueldo en Dólares',
      content_type: 'product',
      value: 7,
      currency: 'USD',
    })
  }
}
